import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { toast } from 'react-toastify';
import TranslationForm from '../components/TranslationForm';
import { getTag, createTag, updateTag } from '../../../services/blogService';
import { Input } from '../../../components/ui/Input';
import { Button } from '../../../components/ui/Button';

function TagEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditing = !!id;

  const [loading, setLoading] = useState(isEditing);
  const [formData, setFormData] = useState({
    slug: '',
    translations: [{ language_code: 'tr', name: '' }]
  });

  useEffect(() => {
    if (isEditing) {
      loadTag();
    }
  }, [id]);

  const loadTag = async () => {
    try {
      setLoading(true);
      const response = await getTag(id);
      if (response.state && response.data) {
        const tag = response.data;
        setFormData({
          slug: tag.slug || '',
          translations: tag.translations || [{ language_code: 'tr', name: '' }]
        });
      }
    } catch (error) {
      console.error('Error loading tag:', error);
      toast.error('Etiket yüklenirken hata oluştu');
      navigate('/panel/blog?tab=tags');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      if (isEditing) {
        await updateTag(id, formData);
        toast.success('Etiket başarıyla güncellendi');
      } else {
        await createTag(formData);
        toast.success('Etiket başarıyla oluşturuldu');
      }

      navigate('/panel/blog?tab=tags');
    } catch (error) {
      console.error('Error saving tag:', error);
      toast.error(error.response?.data?.message || 'Etiket kaydedilirken hata oluştu');
    }
  };

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px] gap-4">
        <Loader2 className="w-8 h-8 animate-spin text-zinc-500" />
        <p className="text-zinc-400 text-sm">Yükleniyor...</p>
      </div>
    );
  }

  return (
    <div className="p-8 space-y-8 max-w-2xl mx-auto">
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('../?tab=tags')}
          className="gap-2"
        >
          <ArrowLeft className="w-4 h-4" />
          Geri
        </Button>
        <h1 className="text-2xl font-bold text-zinc-100">
          {isEditing ? 'Etiket Düzenle' : 'Yeni Etiket Oluştur'}
        </h1>
      </div>

      <div className="grid grid-cols-1 gap-8">
        <div className="space-y-1.5">
          <label className="text-xs text-gray-500 uppercase font-semibold">Slug</label>
          <Input
            value={formData.slug}
            onChange={(e) => setFormData({ ...formData, slug: e.target.value })}
            placeholder="etiket-slug"
          />
        </div>

        <div>
          <TranslationForm
            translations={formData.translations}
            onChange={(translations) => setFormData({ ...formData, translations })}
            fields={['name']}
          />
        </div>

        <div className="flex justify-end gap-3 pt-6 border-t border-zinc-800">
          <Button variant="ghost" onClick={() => navigate('../?tab=tags')}>
            İptal
          </Button>
          <Button onClick={handleSave} className="px-8">
            Kaydet
          </Button>
        </div>
      </div>
    </div>
  );
}

export default TagEditPage;

